import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toRight",
  "use": "icon-toRight-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-toRight\">\n  <g id=\"icon-toRight_Frame\" clip-path=\"url(#icon-toRight_clip0_1616_11317)\">\n    <path id=\"icon-toRight_Vector\" d=\"M14.25 8.75H3.33333C2.8731 8.75 2.5 9.1231 2.5 9.58333V9.58333C2.5 10.0436 2.8731 10.4167 3.33333 10.4167H14.25L12.25 12.4167C11.9278 12.7388 11.9278 13.2612 12.25 13.5833V13.5833C12.5722 13.9055 13.0945 13.9055 13.4167 13.5833L16.787 10.213C17.1357 9.86432 17.1383 9.29978 16.7928 8.9479L13.502 5.59619C13.1796 5.26781 12.6513 5.26539 12.3259 5.59079V5.59079C12.0063 5.91035 12.0021 6.42715 12.3164 6.75191L14.25 8.75Z\" fill=\"currentColor\" />\n  </g>\n  <defs>\n    <clipPath id=\"icon-toRight_clip0_1616_11317\">\n      <rect width=\"20\" height=\"20\" fill=\"white\" />\n    </clipPath>\n  </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/toRight.svg
// module id = zFwo
// module chunks = 103